import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Inventario" },
  { label: "Almacenes",          icon: "fas fa-warehouse",      color: "#3b82f6", bg: "#eff6ff", href: "/Areas",                    desc: "Catálogo de almacenes",        perm: "inventarios"            },
  { label: "Inventario General", icon: "fas fa-boxes",          color: "#10b981", bg: "#f0fdf4", href: "/ListadoInventarios",        desc: "Stock general",                perm: "inventarios"            },
  { label: "Inv Disponible",     icon: "fas fa-tasks",          color: "#0ea5e9", bg: "#f0f9ff", href: "/MenuDisponibles",           desc: "Disponibilidad de stock",      perm: "menu_disponible"        },
  { label: "Reporte Stock",      icon: "fas fa-chart-bar",      color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoInventariosStock",   desc: "Reporte de existencias",       perm: "inventarios"            },

  { type: "section", label: "Movimientos" },
  { label: "Solicitud Traspaso", icon: "fas fa-file-export",    color: "#f97316", bg: "#fff7ed", href: "/ListadoTraspasosSolicitud", desc: "Solicitudes de traspaso",      perm: "menu_traspasos_salida"  },
  { label: "Pend Traspasar",     icon: "fas fa-truck-moving",   color: "#ef4444", bg: "#fef2f2", href: "/ListadoPendienteTraspasar", desc: "Solicitudes pendientes",       perm: "menu_traspasos_salida"  },
  { label: "Traspasos Salida",   icon: "fas fa-sign-out-alt",   color: "#dc2626", bg: "#fef2f2", href: "/ListadoTraspasosSalida",    desc: "Traspasos enviados",           perm: "menu_traspasos_salida"  },
  { label: "Ajuste Inventario",  icon: "fas fa-plus-circle",    color: "#10b981", bg: "#f0fdf4", href: "/ListadoAjustesInventario",  desc: "Ajustes de inventario",        perm: "ajustesInventario"      },

  { type: "section", label: "Consultas y Trazabilidad" },
  { label: "Tracking",           icon: "fas fa-search",         color: "#f59e0b", bg: "#fffbeb", href: "/ListadoTracking",           desc: "Seguimiento de inventarios",   perm: "seguimiento_inventarios"},
  { label: "Kardex",             icon: "fas fa-clipboard-list", color: "#6366f1", bg: "#eef2ff", href: "/ListadoKardex",             desc: "Movimientos por artículo",     perm: "seguimiento_inventarios"},
  { label: "Lotes por Artículo", icon: "fas fa-thumbtack",      color: "#64748b", bg: "#f8fafc", href: "/ListadoLotes",              desc: "Lotes agrupados por artículo", perm: "menu_inventarios"       },
  { label: "Lotes",              icon: "fas fa-map-marked-alt", color: "#64748b", bg: "#f8fafc", href: "/ListadoLotes2",             desc: "Vista de lotes",               perm: "menu_inventarios"       },
  { label: "Consulta IMEI",      icon: "fas fa-mobile-alt",     color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoIMEIs",              desc: "Registro de IMEIs / series",   perm: "menu_inventarios"       },
];

function BotonesInventarios() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-boxes" color="#10b981" bg="#f0fdf4" title="Inventarios" subtitle="Control de stock y traspasos" />
        {user.menu_inventarios ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesInventarios;
